import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/material-module/confirm-dialog/confirm-dialog.component';
import { dataTableColumnDefinition } from 'src/app/shared/resourceful-index/dataTableColumnDefinition';
import { ResourcefulIndexComponent } from 'src/app/shared/resourceful-index/resourceful-index/resourceful-index.component';
import { EditFilialeComponent } from './dialogs/edit/edit.component';
import { FilialeService } from '../../services/filiale.service';
import { Filiale } from '../../models/filiale';

@Component({
  selector: 'filiali',
  templateUrl: './filiali.component.html',
  styleUrls: ['./filiali.component.scss']
})
export class FilialiComponent implements OnInit {
  headingText: string = 'Filiali';

  relations: string[] = [];

  @ViewChild('index') index: ResourcefulIndexComponent;

  selectionMode: boolean = false;

  loading: boolean = true;

  search: any;

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition(
      {
        humanName: 'ID',
        internalName: 'id',

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Nome',
        internalName: 'nome',

      }
    ),
  ];
  constructor(
    public filialeService: FilialeService,
    public dialog: MatDialog,
    private toast: ToastrService,
    @Optional() private dialogRef: MatDialogRef<FilialiComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,) {
    if (this.data?.selectionMode) {
      this.selectionMode = true;
      this.headingText = 'Seleziona una filiale';
    }
  }

  form: FormGroup;
  ngOnInit() {

    this.form = this.fb.group({
      nome: [],
    });

    this.form.valueChanges.subscribe(newValues => this.search = newValues);

  }

  async ngAfterViewInit(): Promise<void> {
    await this.updateDataSource();
    this.loading = false;
  }

  closeDialogWithSelectedModel(model) {
    this.dialogRef?.close(model);
  }

  async updateDataSource() {
    await this.index?.updateData();
  }


  deleteFunction = async (filiale: Filiale) => {
    try {
      let dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { message: `Sei sicuro di voler eliminare la filiale ${filiale.nome}?` } });
      dialogRef.afterClosed().subscribe(async data => {
        if (data) {
          await this.filialeService.delete(filiale);
          this.toast.success('Filiale eliminata.');
          this.updateDataSource();
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Eliminazione filiale fallita.", "Errore!");
    }
  }



  editFunction = async (filiale: Filiale) => {
    try {
      let dialogRef = this.dialog.open(EditFilialeComponent, { data: filiale });
      dialogRef.afterClosed().subscribe(async (data: Filiale) => {
        if (data) {

          Object.assign(filiale, data);
          await this.filialeService.edit(filiale);

          this.toast.success('Filiale modificato');
          this.updateDataSource();

        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Modifica filiale fallita.", "Errore!");
    }
  }


  add() {
    let addDialogRef = this.dialog.open(EditFilialeComponent, { data: this.search });
    addDialogRef.afterClosed().subscribe(data => this.handleCreation(data));
  }

  async handleCreation(filiale?: Filiale) {
    if (filiale) {
      try {
        await this.filialeService.create(filiale)
        this.toast.success('Filiale creata!')
      }
      catch (e) {
        this.toast.error('Creazione filiale fallita.', 'Errore!');
      }
      finally {
        this.updateDataSource();
      }

    }
  }



}
